import React from 'react';
import { Wallet, CreditCard } from 'lucide-react';

const eur = (v) => `${Number(v || 0).toFixed(2).replace('.', ',')} €`;

/* Choix « payer avec mon compte client » : le solde est utilisé en premier, le reste part sur Stripe. */
export const splitAccount = (total, balance, useAccount) => {
  const t = Math.max(0, Number(total) || 0);
  const b = Math.max(0, Number(balance) || 0);
  const part = useAccount ? Math.min(t, b) : 0;
  return { account: Math.round(part * 100) / 100, stripe: Math.round((t - part) * 100) / 100 };
};

export const AccountPayChoice = ({ total, balance, useAccount, onChange, testId = 'account-pay-choice' }) => {
  const t = Number(total) || 0;
  const b = Number(balance) || 0;
  if (t <= 0 || b <= 0) return null;
  const { account, stripe } = splitAccount(t, b, useAccount);
  return (
    <div className="rounded-xl border p-3 space-y-2" style={{ backgroundColor: useAccount ? '#eff6ff' : '#fff', borderColor: useAccount ? '#93c5fd' : '#e5e7eb' }} data-testid={testId}>
      <label className="flex items-center justify-between gap-3 cursor-pointer">
        <div className="flex items-center gap-2.5 min-w-0">
          <Wallet size={16} className="text-blue-600 flex-shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold text-neutral-800">Utiliser mon compte client</p>
            <p className="text-[10px] text-neutral-500">Solde disponible : <span className="font-semibold text-blue-700" data-testid={`${testId}-balance`}>{eur(b)}</span></p>
          </div>
        </div>
        <input type="checkbox" checked={!!useAccount} onChange={(e) => onChange(e.target.checked)} className="w-4 h-4 rounded accent-blue-600" data-testid={`${testId}-toggle`} />
      </label>
      {useAccount && (
        <div className="text-[11px] space-y-0.5 border-t pt-2" style={{ borderColor: '#bfdbfe' }}>
          <div className="flex justify-between"><span className="text-neutral-600">Pris sur mon compte</span><span className="font-semibold text-blue-700" data-testid={`${testId}-account`}>− {eur(account)}</span></div>
          <div className="flex justify-between items-center">
            <span className="text-neutral-600 flex items-center gap-1"><CreditCard size={11} /> Reste à payer en ligne</span>
            <span className="font-semibold" style={{ color: stripe > 0 ? '#2E6A4C' : '#059669' }} data-testid={`${testId}-stripe`}>{stripe > 0 ? eur(stripe) : 'Rien — tout est réglé par le compte'}</span>
          </div>
        </div>
      )}
    </div>
  );
};

/* Libellé du bouton de paiement selon la répartition compte / Stripe. */
export const payLabel = (total, balance, useAccount, verb = 'et réserver') => {
  const { account, stripe } = splitAccount(total, balance, useAccount);
  if (total <= 0) return null;
  if (account > 0 && stripe <= 0) return `Confirmer — ${eur(account)} sur mon compte`;
  if (account > 0) return `Payer ${eur(stripe)} en ligne (+ ${eur(account)} sur mon compte) ${verb}`;
  return `Payer ${eur(total)} ${verb}`;
};
